class BannerTxtOverlay {
  constructor(parent) {
    if (!parent) {
      return;
    }

    this.parent = parent;
    this.Slider();
  }

  Slider = () => {
    let parent = this.parent;
    let BannerTxtOverlaySlider = qsa(
      ".section-banner-txt-overlay .banner-text-slider-js"
    );
    BannerTxtOverlaySlider.length > 0 &&
      BannerTxtOverlaySlider.forEach((el) => {
        this.swiper(el);
      });
  };

  swiper = (element) => {
    let loop = element.getAttribute("data-loop") == "true" ? true : false;
    let autoplay =
      element.getAttribute("data-auto-rotate") == "true" ? true : false;
    let time = parseInt(element.getAttribute("data-slide-time")) * 1000;
    let navigation =
      element.getAttribute("data-arrow") == "true" ? true : false;
    let pagination =
      element.getAttribute("data-pagination") == "true" ? true : false;
    let elId = element.getAttribute("data-id");

    let options = {
      loop,
      slidesPerView: 1,
      spaceBetween: 5,
    };

    if (navigation) {
      options["navigation"] = {
        nextEl: `.${elId} .swiper-button-next`,
        prevEl: `.${elId} .swiper-button-prev`,
      };
    }

    if (pagination) {
      options["pagination"] = {
        el: `.${elId} .swiper-pagination`,
        dynamicBullets: true,
        clickable: true,
      };
    }

    if (autoplay) {
      options["autoplay"] = {
        delay: time,
      };
    }

    let swiper = new Swiper(element, options);
  };
}

// document.addEventListener("DOMContentLoaded", function () {
//   const playButton = document.querySelector(".video-wrapper .video-play");
//   const pauseButton = document.querySelector(".video-wrapper .video-pause");

//   playButton?.addEventListener('click', function() {
//     renderIframePlay();
//   });

//   pauseButton?.addEventListener('click', function() {
//     renderIframePause();
//   });

//   function renderIframePlay() {
//     setTimeout(() => {
//       var iframe = document.getElementById('videoFrame');
//       iframe.contentWindow.postMessage( '{"event":"command", "func":"playVideo", "args":""}', '*');
//     }, 500);
//     if(pauseButton) {
//       pauseButton.style.display='block';
//     }
//     if(playButton) {
//       playButton.style.display='none';
//     }
//   }
//   function renderIframePause(){
//     setTimeout(() => {
//       var iframe = document.getElementById('videoFrame');
//       iframe.contentWindow.postMessage( '{"event":"command", "func":"pauseVideo", "args":""}', '*');
//     }, 500);
//     pauseButton.style.display='none';
//     playButton.style.display='block';
//   }
// });


document.addEventListener("DOMContentLoaded", function() {

  var playButtons = document.querySelectorAll(".video-play-pause-js");
if(playButtons){
  playButtons.forEach(function(playButton) {

    var video = playButton.closest(".media-wrapper").querySelector("video");


    playButton.addEventListener("click", function() {
            if (video.paused) {

        video.play();

        playButton.querySelector(".video-play").style.display = "none";
        playButton.querySelector(".video-pause").style.display = "block";
      } else {

        video.pause();

        playButton.querySelector(".video-pause").style.display = "none";
        playButton.querySelector(".video-play").style.display = "block";
      }
    });
  });
}

});
 






new BannerTxtOverlay(qs(".section-banner-txt-overlay"));
